import * as salaryConstant from './constants'

export const salaryReportDetailNvkdRequest = (formData) => {
  return {
    type: salaryConstant.SALARY_REPORT_DETAIL_NVKD_REQUESTING,
    payload: formData,
  }
}

export const salaryReportDetailNvkdSuccess = (data) => {
  return {
    type: salaryConstant.SALARY_REPORT_DETAIL_NVKD_SUCCESS,
    payload: data,
  }
}

export const salaryReportDetailNvkdError = (error) => {
  return {
    type: salaryConstant.SALARY_REPORT_DETAIL_NVKD_ERROR,
    payload: error,
  }
}
export const salaryReportDetailListRequest = (formData) => {
  return {
    type: salaryConstant.SALARY_REPORT_DETAIL_LIST_REQUESTING,
    payload: formData
  }
}

export const salaryReportDetailListSuccess = (data) => {
  return {
    type: salaryConstant.SALARY_REPORT_DETAIL_LIST_SUCCESS,
    payload: data
  }
}

export const salaryReportDetailListError = (error) => {
  return {
    type: salaryConstant.SALARY_REPORT_DETAIL_LIST_ERROR,
    payload: error
  }
}

export const reportExportXlsRequest = (formData, callback) => {
  return {
    type: salaryConstant.SALARY_REPORT_DETAIL_EXPORT_XLS_REQUESTING,
    payload: formData,
    callback
  }
}

export const reportExportXlsSuccess = (data) => {
  return {
    type: salaryConstant.SALARY_REPORT_DETAIL_EXPORT_XLS_SUCCESS,
    payload: data
  }
}

export const reportExportXlsError = (error) => {
  return {
    type: salaryConstant.SALARY_REPORT_DETAIL_EXPORT_XLS_ERROR,
    payload: error
  }
}


// WEBPACK FOOTER //
// ./src/views/Reports/SalaryReportDetail/actions.js